// ajax-progress-type.es6.js

(($, Drupal) => {
  /**
   * Override AJAX "beforeSend" callback.
   */
  const originalAjaxBeforeSend = Drupal.Ajax.prototype.beforeSend;
  // eslint-disable-next-line func-names
  Drupal.Ajax.prototype.beforeSend = function (xmlhttprequest, options) {
    const $element = $(this.element);

    // Set progress type from "data-progress-type" attribute
    // @TODO Remove after close issue https://www.drupal.org/project/drupal/issues/2818463
    if ($element.data("progress-type")) {
      this.progress.type = $element.data("progress-type");
    }

    // Call original callback
    originalAjaxBeforeSend.apply(this, [xmlhttprequest, options]);
  };
})(jQuery, Drupal);
